(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-abv-members]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const form = link.closest('.catalog-filters');
    if (!form) return;
    event.preventDefault();
    const members = link.dataset.abvMembers.split('|').filter(Boolean);
    const selected = !link.classList.contains('is-active');
    form.querySelectorAll('input[type=checkbox]').forEach(input => {
      if (input.name === link.dataset.abvParam && members.includes(input.value) && !input.disabled) input.checked = selected;
    });
    // Submit all current controls, including an adjusted price range and sorting.
    form.requestSubmit();
  });
})();